import React from 'react';
import TextInput from '../../../inputs/TextInput';
import classNames from 'classnames';
import SearchIcon from '../../../../assets/icons/actions/SearchIcon';
import useScreenType from '../../../../hooks/utility/useScreenType';
import CloseIcon from '../../../../assets/icons/actions/CloseIcon';
import Theme from '../../../Theme';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type SearchProps = {
  className?: string;
};

const SearchInput = (props: SearchProps) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:MenuNavigationBar:SearchInput' });
  const { isMobile } = useScreenType();
  const { className } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = searchParams.get('search');
  const cnClassName = classNames('w-[350px] h-9 mx-0 space-x-2 !rounded-full');
  const toggleSearch = () => {
    searchParams.delete('search');
    setSearchParams(searchParams);
  };
  const onChange = (val: string) => {
    searchParams.set('search', val);
    setSearchParams(searchParams);
  };
  const clearSearch = () => {
    searchParams.set('search', '');
    setSearchParams(searchParams);
  };

  return (
    <div
      className={classNames(
        {
          'flex space-x-2 flex-row items-center justify-between mb-none': isMobile,
        },
        className,
      )}
    >
      <TextInput
        value={searchValue}
        onChange={onChange}
        className="order-2 placeholder:text-gray-700"
        autoFocus={isMobile}
        placeholder={t('placeholder')}
        leftIcon={
          <>
            {!!searchValue?.length && (
              <button className="order-3" onClick={clearSearch}>
                <CloseIcon className="size-3" color={Theme.color.gray['700']} />
              </button>
            )}
          </>
        }
        rightIcon={
          <>
            {!searchValue?.length && (
              <span>
                <SearchIcon className="size-4" />
              </span>
            )}
          </>
        }
        inputContainerStyle={cnClassName}
      />
      {isMobile && (
        <button className="text-gray-700 font-medium" onClick={toggleSearch}>
          {t('cancel')}
        </button>
      )}
    </div>
  );
};

export default SearchInput;
